import { render, staticRenderFns } from "./GlobalStompDebugPanel.vue?vue&type=template&id=0b2d1dda&scoped=true"
import script from "./GlobalStompDebugPanel.vue?vue&type=script&lang=js"
export * from "./GlobalStompDebugPanel.vue?vue&type=script&lang=js"
import style0 from "./GlobalStompDebugPanel.vue?vue&type=style&index=0&id=0b2d1dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2d1dda",
  null
  
)

export default component.exports